import { Controller } from "@hotwired/stimulus";
import * as Rails from "@rails/ujs";

export default class extends Controller {
  connect() {
    Rails.fire(this.element, 'submit')
  }
}
